import React from 'react';
import { ModalNoAccessToStreamingStyle } from './style';

export default function ModalNoAccessToStreaming({ setNoAccessToStreaming }) {
  return (
    <ModalNoAccessToStreamingStyle>
      <div>
        <label>
          <button onClick={() => setNoAccessToStreaming(false)}>X</button>
        </label>
        <img src="/images/icons/iconAlertBox.svg" alt="ícone de alerta" />
        <p>
          Me perdoe, mas o acesso a este <span>streaming</span> de vídeo não está disponível para este usuário.
        </p>
        <p>
          Entre em contato com o nosso Suporte Técnico através do{' '}
          <img src="/images/icons/iconWhatsapp.svg" alt="ícone do Whatsapp" style={{ width: '15px' }} /> (11) 4994-0591
          ou <img src="/images/icons/iconEmail.svg" alt="ícone de email" style={{ width: '15px' }} />{' '}
          SuporteTI@spa-br.com informando seu código de cliente!
        </p>
        <p>Aproveito para lembrar que nosso horário de atendimento é das 08:00 às 17:00.</p>
        <p>Obrigado!</p>
      </div>
    </ModalNoAccessToStreamingStyle>
  );
}
